module.exports = __webpack_public_path__ + "static/media/receive.bfc92be7.png";